import { QuestionModel } from "../models/QuestionModel";
import { ValidatorFunction } from "./VariableErrorModel";
import { QuestionType } from "../models/enums/QuestionType";
import answerRequired from "./rules/answerRequired";
import maxMentions from "./rules/maxMentions";
import openEndRequired from "./rules/openEndRequired";
import openEndMinimumLength from "./rules/openEndMinimumLength";
import openEndMaximumLength from "./rules/openEndMaximumLength";
import softPrompt from "./rules/softPrompt";
import { VariableType } from "../models/enums/VariableType";
import { validNumber } from "./rules/validNumber";
import { numberOfDecimals } from "./rules/numberOfDecimals";
import { minValue } from "./rules/minValue";
import { maxValue } from "./rules/maxValue";
import { bounds } from "./rules/bounds";
import { isQuestionValidatedServerSide } from "../models/utilities/validationUtilities";

export const newValidationQuestionTypes = (): QuestionType[] => [
    QuestionType.RadioButton,
    QuestionType.DropDownList,
    QuestionType.AutoComplete,
    QuestionType.Slider,
    QuestionType.NetPromoter,
    QuestionType.RespondentLanguage,
    QuestionType.RespondentTimeZone,
    QuestionType.NumericAnswer,
];

export function answerRequiredValidators(
    question: QuestionModel,
    useClientValidation?: boolean,
): ValidatorFunction[] {
    if (newValidationQuestionTypes().includes(question.type)) {
        const bypassClientValidation = isQuestionValidatedServerSide(
            question.type,
            useClientValidation,
        );

        if (!bypassClientValidation) {
            return [answerRequired(question), softPrompt(question)];
        }
        return [];
    }
    return [];
}

export function questionValidators(
    question: QuestionModel,
    useClientValidation?: boolean,
): ValidatorFunction[] {
    const [variable] = question.variables.filter((v) => v.type !== VariableType.Computed);

    const bypassClientValidation = isQuestionValidatedServerSide(
        question.type,
        useClientValidation,
    );

    if (!variable || bypassClientValidation) {
        return [];
    }
    const { type } = variable;
    switch (question.type) {
        case QuestionType.RadioButton:
        case QuestionType.DropDownList:
            return [
                maxMentions(variable),
                openEndRequired(variable),
                openEndMinimumLength(variable),
                openEndMaximumLength(variable),
            ];
        case QuestionType.AutoComplete:
        case QuestionType.NetPromoter:
        case QuestionType.RespondentLanguage:
        case QuestionType.RespondentTimeZone:
            return [maxMentions(variable)];
        case QuestionType.Slider:
            if (type === VariableType.Discrete) {
                return [maxMentions(variable)];
            }
            return [];
        case QuestionType.NumericAnswer:
            return [
                maxMentions(variable),
                validNumber(variable),
                numberOfDecimals(question, variable),
                bounds(question, variable),
                minValue(question, variable),
                maxValue(question, variable),
            ];
        default:
            return [];
    }
}
